{
  "colorInputLabel": "{label}、{channelLabel}",
  "colorNameAndValue": "{name} : {value}",
  "colorPicker": "カラーピッカー",
  "twoDimensionalSlider": "2D スライダー",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
